import { useQueryClient } from '@tanstack/react-query';
import type { ContentObject, GivingContentObjectDetail, GivingContentObjectList } from 'models';
import { useCallback } from 'react';
import type { UpdateLikeProperties } from 'features/like';
import { getGivingDetailQueryKey } from '../queries';

export const useUpdateGivingLike = () => {
  const queryClient = useQueryClient();

  return useCallback(
    (params: {
      action: UpdateLikeProperties['action'];
      contentObject: GivingContentObjectDetail | GivingContentObjectList;
    }) => {
      queryClient.setQueriesData<ContentObject>(
        { queryKey: getGivingDetailQueryKey({ givingId: params.contentObject.giving.id, view: 'internal' }) },
        (giving) => {
          if (!giving) {
            return giving;
          }

          return {
            ...giving,
            liked: !params.contentObject.liked,
            likesCount: params.contentObject.likesCount + (params.action === 'like' ? 1 : -1),
          };
        },
      );
    },
    [queryClient],
  );
};
